export default function CustomMeta({ title, content, className = '' }) {
  return (
    <div className={`text-lg ${className}`}>
      <label className="font-bold">{title}: </label>
      <span>{content}</span>
    </div>
  )
}
